/***
 * 创建人：李珊
 * 时间：2020-02-06
 * 描述: 查看素材详情-新增或编辑图像
 * 使用说明:
 * 更新说明:
 */
import { Component, OnInit, ViewChild, Output, Input, EventEmitter } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { KmsService } from '../../../../kms.service';
import { KmsEnum } from 'src/app/areas/kms/serves/kms-enum';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
@Component({
  selector: 'app-img-addorupdate',
  templateUrl: './img-addorupdate.component.html',
  styleUrls: ['./img-addorupdate.component.css']
})
export class ImgAddorupdateComponent implements OnInit {
  //弹出层组件
  @ViewChild('modal') modal: SwModalframeComponent; 
  //输入参数
  @Input() param: any;  
  //抛出事件
  @Output() callback = new EventEmitter(); 
  //标题
  headerLoGo:string;   
  formModel:any = {};   
  //保存按钮是否可点击
  clickEnable = true;
  // 封面图上传文件策略
  autoCode:string = '';

  constructor(
    private kmsService: KmsService,
    private box:SwMassageBoxService,
    private jwt: SwJwtService
  ) { 

  }

  ngOnInit() {
    // 通过知识库标识拼接文件策略
    let kgDbInfo = JSON.parse(this.jwt.getToken('kgDbInfo'));
    let kgCode = kgDbInfo && kgDbInfo.englishCode ? kgDbInfo.englishCode : '';
    this.autoCode = kgCode ? KmsEnum.KMS_INSTANCE_IMG_RESOURCE + '_' + (kgCode.toUpperCase()) : '';
    // 查询表格详情
    this.clickLoca(this.param);
  }

  clickLoca(params: any){
    this.formModel.materialRelId = params.materialRelId;
    let upOrAddStr;
    //当前操作为编辑时
    if(params.upOrAdd == "Edit"){
      upOrAddStr = '编辑';
      this.headerLoGo = upOrAddStr + '图像';
      this.getDetailById();
    }else{//当前操作为新增时
      upOrAddStr = '新增';
      this.headerLoGo = upOrAddStr + '图像';
      this.formModel.parentMaterialId = params.materialId;
      this.formModel.relType = 1;
    }
  }

  // 根据主键id查询目录信息
  getDetailById() {
    this.kmsService.queryMaterialPicOrTableById(this.formModel.materialRelId).subscribe(
      data => {
        if (data.code == 200) {
          this.formModel = data.data;
        } else {
          this.box.waring(data.msg);
        }
      }
    );
  }

  // 上传头像成功的回调
  headImgAdd(event){
    if (event.length > 0) {
      let params = [];
      let element = event[0];
      let thumbnailPath = "";
      if (element.fileType == "FILE_TYPE_PICTURE") {
          let index = element.fileName.lastIndexOf(".");
          let name =
              element.fileName.substring(0, index) +
              "_300@x." +
              element.fileSuffix;
          thumbnailPath = element.filePath + "THUMB/" + name;
      }
      let arr = element.fileOldname.split(".");
      let fileName = "";
      for (let i = 0; i < arr.length - 1; i++) {
          if (i == arr.length - 2) {
              fileName += arr[i];
          } else {
              fileName += arr[i] + ".";
          }
      }
      let category = "FILE_TYPE_PICTURE";
      // 获取用户角色
      const userRole = this.jwt.getToken('userRole');
      let entity = {
          fileId: element.fileInfoId,
          fileSuffix: element.fileSuffix,
          materialTitle: fileName,
          filePath: element.filePath + element.fileName,
          materialCategory: category,
          fileThumbnail: thumbnailPath,
          accessType: 1,
          approvalStatus: 0,
          currentUserRole: userRole == '知识编辑' ? 1 : 2,
          status: 0,
          textExtractStatus: 0
      };
      params.push(entity);
      if(!this.formModel.name){
        this.formModel.name = fileName;
      }
      // 保存资源信息
      this.kmsService.saveOrUpdateMaterial(params).subscribe((data) => {
          if (data.code == "200") {
            this.updateESMaterialInfo(data.data);
            this.formModel.childMaterialId = data.data ? data.data[0] : '';
          } else {
            console.log(data.msg);
          }
      });
    }
  }

  // 更新资源es信息
  updateESMaterialInfo(ids){
    if(ids.length == 0){
        return;
    }
    this.kmsService.updateESMaterialInfo({"materialIdList":ids}).subscribe(
      data => {
        if (data["code"] != 200) {
          this.box.danger(data.msg);
        }
      }
    )
  }

  // 删除图像成功的回调
  headImgDelete(event){
    this.deleteEs();
  }

  // 删除资源es信息
  deleteEs(){
    // 删除es信息
    this.kmsService.deleteESMaterialInfo([this.formModel.childMaterialId]).subscribe(
      data => {
        if (data["code"] != 200) {
          this.box.danger(data.msg);
        }else{
          // 删除素材信息
          this.kmsService.deleteMaterialById([this.formModel.childMaterialId]).subscribe(
            data => {
              if (data["code"] == '200') {
                this.formModel.childMaterialId = '';
              } else {
                console.log(data.msg);
              }
            }
          )
        }
      }
    )
  }

  //表单提交
  onSubmit({ value, valid }, event: Event) {
    if(!this.formModel.childMaterialId){
      this.box.waring('请上传图像！');
      return;
    }
    this.clickEnable = false;
    // 保存素材与图像的关联信息
    let func;
    if(this.param.upOrAdd == 'Add'){
      func = this.kmsService.saveMaterialRel(this.formModel);
    }else{
      func = this.kmsService.updateMaterialRel({
        "materialRelId": this.formModel.materialRelId,
        "name": this.formModel.name,
        "pagesNum": this.formModel.pagesNum,
        "childMaterialId": this.formModel.childMaterialId
      });
    }
    func.subscribe(data => {
      this.clickEnable = true;
      if (data['code'] == 200) {
        this.box.success('保存成功!');
        // 关闭框
        this.modal.toggle();
        // 回调
        this.callback.emit(true);
      } else {
        this.box.danger('保存失败!');
      }
    });
    // 修改素材名称
    this.kmsService.saveMaterialInfo(
      {
        'materialId':this.formModel.childMaterialId,
        'materialTitle':this.formModel.name,
      }
    ).subscribe(
      data => {
        if(data.code == '200'){
          this.updateESMaterialInfo([this.formModel.childMaterialId]);
        }else{
          this.box.danger('素材信息保存失败！');
        }
      }
    );
  }
}


